<template lang="pug">
  component(:is="renderEl" name="expand" @after-enter="afterEnter" @enter="enter" @leave="leave")
    slot
</template>

<script>
  import { defineComponent, Transition, TransitionGroup } from 'vue';

  export default defineComponent({
    name: 'TransitionExpand',

    props: {
      group: {
        type: Boolean,
        default: false,
      },
    },

    computed: {
      renderEl() {
        // Check if we're in SSR mode
        if (import.meta.env.SSR) {
          return this.group ? TransitionGroup : Transition;
        }
        
        // Only access window in client-side
        if (typeof window !== 'undefined' && /Trident\/|MSIE/.test(window.navigator.userAgent)) {
          return 'div';
        }
        return this.group ? TransitionGroup : Transition;
      },
    },

    methods: {
      afterEnter(element) {
        element.style.height = 'auto';
      },

      enter(element) {
        const { width } = getComputedStyle(element);
        element.style.width = width;
        element.style.position = 'absolute';
        element.style.visibility = 'hidden';
        element.style.height = 'auto';

        const { height } = getComputedStyle(element);
        element.style.width = null;
        element.style.position = null;
        element.style.visibility = null;
        element.style.height = 0;
        getComputedStyle(element).height;
        setTimeout(() => {
          element.style.height = height;
        });
      },

      leave(element) {
        const { height } = getComputedStyle(element);
        element.style.height = height;
        getComputedStyle(element).height;
        setTimeout(() => {
          element.style.height = 0;
        });
      },
    },
  });
</script>

<style scoped lang="stylus">
*
  will-change height
  transform translateZ(0)
  backface-visibility hidden
  perspective 1000px
</style>

<style lang="stylus">
.expand-enter-active,
.expand-leave-active
  transition height 600ms ease-in-out
  overflow hidden

// Vue 3 transition classes
.expand-enter-from,
.expand-leave-to
  height 0

// Keep Vue 2 classes for backwards compatibility if needed
.expand-enter,
.expand-leave-to
  height 0
</style>
